import React, { useMemo } from 'react';
import { DropdownButton } from '@minecraft.molecules';
import { useTranslation } from '@blocs.i18n';

export type AddMediaDDProps = {
  mutationLoading?: boolean;
  openMediaBin: () => void;
  openMediaUploader: () => void;
  toggleLabel: string;
  uploadNewAllowed: boolean;
};

export const AddMediaDropdown = ({
  mutationLoading,
  openMediaBin,
  openMediaUploader,
  toggleLabel,
  uploadNewAllowed,
}: AddMediaDDProps) => {
  const { t } = useTranslation();
  const menuOptions = useMemo(() => {
    return [
      {
        id: 'media-upload-menu-selectFromMediaLibrary',
        label: t('common:media.upload.selectFromMediaLibrary'),
        onClick: () => openMediaBin(),
        disabled: mutationLoading,
      },
      {
        id: 'media-upload-menu-selectFromDevice',
        label: t('common:media.upload.selectFromDevice'),
        onClick: () => openMediaUploader(),
        disabled: mutationLoading || !uploadNewAllowed,
      },
    ];
  }, [mutationLoading, openMediaBin, openMediaUploader, t, uploadNewAllowed]);

  return (
    <DropdownButton
      toggleLabel={toggleLabel}
      toggleProps={{ isSecondary: true, disabled: mutationLoading, mobileBlock: true, size: 'small' }}
      menuItemsProps={menuOptions}
      mobileBlock
    />
  );
};
